import * as React from "react";
const SvgMenu = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3 8.5H21M3 15.5H21", stroke: "#767676", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgMenu;
